import offsetParentScrollPosition from './offset-parent-scroll-position';
import offsetParent from './offset-parent';
import position from './position';

export default function (element, parent) {
    var offsetParentElement = parent ? offsetParent(parent) : null;
    var ref = position(element, offsetParentElement);
    var top = ref.top;
    var left = ref.left;
    var height = ref.height;
    var width = ref.width;
    var ref$1 = offsetParentScrollPosition(offsetParentElement, element);
    var x = ref$1.x;
    var y = ref$1.y;

    return {
        top: top + y,
        left: left + x,
        height: height,
        width: width
    };
};



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-popup-common/dist/es/position-with-scroll.js
// module id = ../../../../@progress/kendo-popup-common/dist/es/position-with-scroll.js
// module chunks = 3